import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { convertDecimalMinutesToDuration, scrollToView, showToaster } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import { PAGEPATHS, SIDEBARDATA, USERTYPES } from "components/Common/Constant";
import { useSelector } from "react-redux";

const OrganaizationList = (props) => {
  document.title = "Organization";
  const navigate = useNavigate();
  const [scanData, setScanData] = useState()

  useEffect(() => {
    props.setBreadcrumbItems("Organization", [])
  })

  const user = useSelector((state) => state?.users.users)




  const fetchData = async (url, setHook) => {
    const { data } = await axiosInstance.get(url)
    return data

  }


  const getScanList = async () => {
    try {
      const response = await fetchData(ApiNames.EDIT_ORG_LIST);
      console.log(response, "response");

      const rows = response.data.map((item, index) => ({
        sNo: index + 1 || "N/A",
        branch: item.branch || "N/A",
        Office: item.Office || "N/A",
        status: item.status === 1
          ? <span class="badge bg-success">Active</span>
          : <span class="badge bg-secondary">Disabled</span>,
        SecurityContact: item.SecurityContact || "N/A",
        toggle:
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              checked={item.status === 1}
              onClick={() => handleStatusToggle(item)}
            />
          </div>
        ,
      }));

      setScanData({
        columns: [
          { label: "S.No", field: "sNo", sort: "asc", width: 150 },
          { label: "Organization Name", field: "branch", sort: "asc", width: 100 },
          { label: "Status", field: "status", sort: "asc", width: 100 },
          { label: "Action", field: "toggle", sort: "asc", width: 100 },


        ],
        rows,
      });

    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getScanList()
    if (user) getScanList();
  }, [user]);


  const handleStatusToggle = async (item) => {
    console.log(item, "sedfrdfg");
    const postForm = {
      _id: item._id,
      status: item.status === 1 ? 0 : 1,
      rememberMe: false
    }
    const response = await axiosInstance.post(ApiNames.EDIT_ORG_STATUS, postForm)
    console.log(response.data.status,"drgrtfhygj");
    if (response.data.status === 1) {
      
     await getScanList()
      await showToaster(true,'Status updated successfully.')
    }
  }


  console.log(scanData, "scanData");

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <MDBDataTable responsive striped data={scanData} />
            </CardBody>
          </Card>

        </Col>
      </Row>

    </React.Fragment >
  )
}
export default connect(null, { setBreadcrumbItems })(OrganaizationList)